<div class="chat-overlay card-primary">
  @if (aiChatUrl) {
    <div class="chat-content">
      <iframe [src]="iframeSafeUrl" class="chat-iframe" frameborder="0"></iframe>
    </div>
  } @else {
    <div class="case-picker">
      <p class="picker-title">{{ 'epd.ai-chat.choose-case' | translate | capitalize }}</p>
      <div class="case-list">
        @for (case of cases; track case) {
          <app-case-item [case]="case" (click)="selectCase(case)"></app-case-item>
        }
      </div>
    
    </div>
  }
</div>
